import React, {useState, useEffect, useContext} from 'react';
import {API_URL} from "../../Utils/Config";
import Loader from "../../Utils/Loader";
import {parseHTMLString, safeName} from "../../Utils/Utils";
import SettingsContext from "../../SettingsContext";
import TabNavigation from "../../Layouts/TabNavigation";
import PageTitle from "../../Helpers/PageTitle";

export default function Guidebook() {
    const {settings} = useContext(SettingsContext);
    const [guides, setGuides] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchGuides() {
            try {
                const response = await fetch(`${API_URL}/api/guides/`);
                const data = await response.json();
                setGuides(data.results);
            } catch (error) {
                console.error('Failed to fetch guides:', error);
            }
            setLoading(false);
        }

        fetchGuides();
    }, []);

    return (
        <>
            <PageTitle title={`${settings.favouriteIsland.charAt(0).toUpperCase() + settings.favouriteIsland.slice(1) } Guide Book`} subheading="Here you will find various guides for all things Hydroneer!" imageClass={settings.favouriteIsland} />

            <div className="ui container">
                <div className="ui breadcrumb inverted">
                    <a href="/" className="section">Bridgepour Wiki Home</a>
                    <i className="right angle icon divider"/>
                    <div className="active section">Guide Book</div>
                </div>

                <div className="ui three columns stackable grid homepage-boxes">
                    <div className="column">
                        <div className="ui segment">
                            <h2 className="ui center aligned icon header">
                                <a href="/database"><i className="circular database icon"/></a>
                                Items
                            </h2>
                            <p>Take a look at the items in our Hydroneer wiki item database.</p>
                            <a href="/database" className="ui button brand block fluid">View the database</a>
                        </div>
                    </div>
                    <div className="column">
                        <div className="ui segment">
                            <h2 className="ui center aligned icon header">
                                <a href="/guide-book/towns"><i className="circular map icon"/></a>
                                Towns
                            </h2>
                            <p>Get to know the towns
                                of {settings.favouriteIsland.charAt(0).toUpperCase() + settings.favouriteIsland.slice(1)} along
                                with local store inventories and sellables.</p>
                            <a href="/guide-book/towns" className="ui button brand block fluid">Visit Locations</a>
                        </div>
                    </div>
                    <div className="column">
                        <div className="ui segment">
                            <h2 className="ui center aligned icon header">
                                <a href="/guide-book/digsites"><i className="circular dungeon icon"/></a>
                                Digsites
                            </h2>
                            <p>Learn more about digsites
                                on {settings.favouriteIsland.charAt(0).toUpperCase() + settings.favouriteIsland.slice(1)},
                                what they do and what their nearest conveniences are.</p>
                            <a href="/guide-book/digsites" className="ui button brand block fluid">Start Digging</a>
                        </div>
                    </div>
                    <div className="sixteen wide column">
                        <h3>Guides</h3>

                        <TabNavigation/>

                        <div className="ui bottom attached tab segment active">
                            {loading ? (
                                <Loader/>
                            ) : (
                                guides.filter(guide => guide.gameVersion ? guide.gameVersion.includes(settings.favouriteIsland) : 'bastion').length === 0 ? (
                                    <p>There are no bespoke guides for this island.</p>
                                ) : (
                                    guides.filter(guide => guide.gameVersion ? guide.gameVersion.includes(settings.favouriteIsland) : 'bastion').map(guide => (
                                        <div className="ui segment" key={guide.id}>
                                            <h3>
                                                <a href={`/guide-book/guide/${guide.id}/${safeName(guide.title)}/1`}>
                                                    <i className={`${guide.icon} icon`}/> {guide.title}
                                                </a>
                                            </h3>
                                            <p>{guide.summary}</p>

                                            {guide.pages.length > 1 && (
                                                <details>
                                                    <summary>Pages</summary>
                                                    <br/>
                                                    <div className="button-grid">
                                                        {guide.pages.map(page => (
                                                            <a href={`/guide-book/guide/${guide.id}/${safeName(guide.title)}/${page.order}`} className="column four wide ui brand button">
                                                                {page.title}
                                                            </a>
                                                        ))}
                                                    </div>
                                                </details>
                                            )}
                                        </div>
                                    ))
                                )
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}